import { baseApi } from "configs/store-query";
import { ACCOUNT } from "constants/tags";
import {
  TAccountSelfApiRequest,
  TAccountSelfApiResponse,
  TAccountSelfUpdateApiRequest,
  TAccountSelfUpdateApiResponse,
} from "apis/account/types/account-self-api";

const BASE_PATH = "/accounts/self";

export const accountSelfApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAccountSelf: build.query<
      TAccountSelfApiResponse,
      TAccountSelfApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}`,
        method: "GET",
        ...config,
      }),
      providesTags: [ACCOUNT],
    }),
    updateAccountSelf: build.mutation<
      TAccountSelfUpdateApiResponse,
      TAccountSelfUpdateApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}`,
        method: "PUT",
        ...config,
      }),
      invalidatesTags: [ACCOUNT],
    }),
  }),
});
